/**
 * Created by lihanying on 2017/6/29.
 */
import { GETCLUBREPERTORY, GETREPERTORYDETAIL, GETPERIOD } from './constants'

const initState = {}

export default function (state = initState, action) {
  switch (action.type) {
    case GETCLUBREPERTORY:
      return Object.assign({}, state, { repertoryList: action.payload })
    case GETREPERTORYDETAIL:
      return Object.assign({}, state, { repertoryDetail: action.payload })
    case GETPERIOD:
      return Object.assign({}, state, { period: action.payload })

    default:
      return state
  }
}


// WEBPACK FOOTER //
// ./src/containers/ClubRepertory/reduce.js